import { Typography } from "@mui/material";

export const NoContentSet = () => {
  return (
    <Typography variant="h3" color="text.secondary" sx={{ marginTop: "20px" }}>
      There is no content to set.
    </Typography>
  );
};
